import { AlertDialog, AlertDialogBody, AlertDialogCloseButton, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, MenuItem, useDisclosure } from '@chakra-ui/react';
import { useAppDispatch, useAppSelector } from '../../../hooks';

import { FiTrash2 } from 'react-icons/fi';
import React from 'react';
import { deleteService } from '../../../store/actions';

export const DeleteServiceButton = (props: { id: string; }) => {

    const { id } = props;

    const { isOpen, onOpen, onClose } = useDisclosure();
    const cancelRef: any = React.useRef();

    const { is_deleting_service } = useAppSelector(state => state.servicesReducer);

    const dispatch = useAppDispatch();

    return (
        <>
            <MenuItem icon={<FiTrash2 color={'#f44336'} size={16} />} color={'red.500'} onClick={onOpen}>
                Delete
            </MenuItem>
            <AlertDialog
                motionPreset='slideInBottom'
                leastDestructiveRef={cancelRef}
                onClose={onClose}
                isOpen={isOpen}
                isCentered
            >
                <AlertDialogOverlay />

                <AlertDialogContent>
                    <AlertDialogHeader>Delete service?</AlertDialogHeader>
                    <AlertDialogCloseButton />
                    <AlertDialogBody>
                        Are you sure you want to delete this service?.
                    </AlertDialogBody>
                    <AlertDialogFooter>
                        <Button ref={cancelRef} onClick={onClose}>
                            No
                        </Button>
                        <Button colorScheme='red' ml={3}
                            isLoading={is_deleting_service}
                            onClick={() => dispatch(deleteService(id))}
                        >
                            Yes
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
        </>
    );
};